// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconExclamationCircle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M11 7v7h2V7zm2 10v-2h-2v2z" />,
    <path fillRule="evenodd" d="M12 21a9 9 0 100-18 9 9 0 000 18m7-9a7 7 0 11-14 0 7 7 0 0114 0" />
  );
export default SvgIconExclamationCircle;
